import { useEffect, useState } from "react"
import {
    Toast,
    ToastClose,
    ToastDescription,
    ToastProvider,
    ToastTitle,
    ToastViewport,
} from "@/components/ui/toast"

type ToastData = {
    id: string
    title?: string
    description?: string
    variant?: "default" | "destructive"
}

let toastListeners: Array<(toast: ToastData) => void> = []
let toastId = 0

export function toast(data: Omit<ToastData, "id">) {
    const id = String(++toastId)
    toastListeners.forEach(listener => listener({ ...data, id }))
}

export function Toaster() {
    const [toasts, setToasts] = useState<ToastData[]>([])

    useEffect(() => {
        const listener = (toast: ToastData) => {
            setToasts(prev => [...prev, toast])
            setTimeout(() => {
                setToasts(prev => prev.filter(t => t.id !== toast.id))
            }, 5000)
        }
        toastListeners.push(listener)
        return () => {
            toastListeners = toastListeners.filter(l => l !== listener)
        }
    }, [])

    return (
        <ToastProvider>
            {toasts.map(({ id, title, description, variant }) => (
                <Toast key={id} variant={variant}>
                    <div className="grid gap-1">
                        {title && <ToastTitle>{title}</ToastTitle>}
                        {description && <ToastDescription>{description}</ToastDescription>}
                    </div>
                    <ToastClose />
                </Toast>
            ))}
            <ToastViewport />
        </ToastProvider>
    )
}
